import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./Base/Header";

import Dashboard from "./Dashboard/Dashboard";
import Home from "./Home/Home";
import Landing from "./Landing/Landing";
import useCurrentPath from "./Base/Hooks/usetCurrentPath";

export default function App() {
  const dashHeader = useCurrentPath({
    routes: ["landing"],
  });
  return (
    <>
      {!dashHeader && <Header />}

      <div className={!dashHeader && "wrapper"}>
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="dashboard/*" element={<Dashboard />} />
          <Route path="landing" element={<LandingOuter />} />
        </Routes>
      </div>
    </>
  );
}
const LandingOuter = () => {
  return <Landing />;
};
